// extracted by css-extract-rspack-plugin
export default {"drawer":"wRFXnXBcn4aBJzeF","body":"h7dNoM3bsOBGuZVv","scrollbarContainer":"JpQmpYKJYs2j3rKs","layout":"FmruHl6SHoEC0O7d","aside":"GLJlfos04Nw0gsSB","main":"x155Py6qIB8v7Ibg"};